import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Toolbar } from './Toolbar';
const styles = {
    container: css({
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgb(240, 240, 240)',
    }),
    title: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 12,
        fontWeight: 500,
    }),
    toolbar: css({
        display: 'flex',
        flexDirection: 'row-reverse',
        '& > button': {
            padding: 0,
            paddingLeft: 9,
            minWidth: 'auto',
        },
    }),
};
export function PanelPreferencesToolbar(props) {
    const { title = '', onClose, onSave } = props;
    return (_jsxs("div", { css: styles.container, children: [_jsx("div", { css: styles.title, children: title }), _jsx("div", { css: styles.toolbar, children: _jsxs(Toolbar, { children: [onClose && (_jsx(Toolbar.Item, { onClick: onClose, intent: "danger", icon: "cross" })), onSave && (_jsx(Toolbar.Item, { onClick: onSave, intent: "success", icon: "tick" }))] }) })] }));
}
//# sourceMappingURL=PanelPreferencesToolbar.js.map